import React from 'react';

import {Row, Col, Table, Pagination} from 'antd'
import { useDispatch, useSelector } from 'react-redux';
import { LoadingOutlined } from '@ant-design/icons';
import {atualizaProdutosSelecionados, atualizaListaProdutos, atualizaBuscandoProdutos ,atualizaFiltro} from '../store/gerenciaProdutoReducer';
import { useProduto } from '../../useProduto';
import { Dinheiro } from '../../../Numeros/dinheiro';

const TabelaProdutos = (props)=> {

    const {getApi} = props;
    const {buscarProdutos} = useProduto(getApi)
    const {listaProdutos, informacoesBusca,buscandoProdutos, filtro, produtosSelecionados} = useSelector(state=> state.gestaoProdutoReducer);

    const {qtdProdutos} = informacoesBusca;
    const {page, pageSize} = filtro;

    

    console.log("informacoesBusca",informacoesBusca)
    const dispatch = useDispatch()
    const {columns=[
        {
            title: "Código",
            dataIndex: "codigo",
            sorter: true
        },
        {
            title: "Descricao",
            dataIndex: "descricao",
            sorter: true
        },
        {
            title: "NCM",
            dataIndex: "ncm",
            sorter: true
           
        },
        {
            title: <span style={{textAlign: "right", display:"block"}}>Valor Custo</span>,
            dataIndex: "valorCusto",
            sorter: true,
            render: (value) => {
                return <span style={{textAlign: "right", display:"block"}}><Dinheiro value={value}></Dinheiro></span>
            }
        },
        {
            title: <span style={{textAlign: "right", display:"block"}}>Valor Venda</span>,
            dataIndex: "vUnCom",
            sorter: true,
            render: (value) => {
                return <span style={{textAlign: "right", display:"block"}}><Dinheiro value={value}></Dinheiro></span>
            }

        }
        // ,
        // {
        //     title: "Lucro"
        // }
        
    ]} = props;

    const onChangePagination = async (page, pageSize) => {
        dispatch(atualizaBuscandoProdutos(true));
       
        try{
            const novoFiltro = Object.assign({},filtro, {
                page, pageSize
            })
            const dados = await buscarProdutos(novoFiltro);
            dispatch(atualizaListaProdutos(dados));
            dispatch(atualizaFiltro(novoFiltro));
        } catch(err){
            console.log(err);
        }

        dispatch(atualizaBuscandoProdutos(false));
       
        
    }

    const onChangeTableHandle = {
        "sort": async ({field, order}) => {
            const novoFiltro = Object.assign({}, filtro, {
                sort: {
                    field, order
                }
            });

            dispatch(atualizaBuscandoProdutos(true));

            dispatch(atualizaFiltro(novoFiltro));
            try{
                const dados = await buscarProdutos(novoFiltro);
                dispatch(atualizaListaProdutos(dados));
            } catch(err){
                console.log(err);
            }

            dispatch(atualizaBuscandoProdutos(false));

        }
    }

    const loading = <LoadingOutlined style={{ fontSize: 24 }} spin />;
   
    return <Row style={{marginTop: "10px"}}>
        <Col span={24}>
            <Table
                loading={{
                    indicator: loading,
                    spinning: buscandoProdutos
                }}
                showSorterTooltip={false}
                pagination={false}
                columns={columns}
                dataSource={listaProdutos}
                rowKey={"uuid"}
                onChange={(pagination, filters,  sorter, extra)=>{
                    onChangeTableHandle[extra.action] && onChangeTableHandle[extra.action](sorter)     
                }}

                onRow={(record, rowIndex) => {
                    return {

                        onClick: event => {
                            let indice = -1;
                            const produtosSelecionadosComMesmoUUID = produtosSelecionados.find(p => {
                                indice++;
                                if( p.uuid === record.uuid ){
                                    return true;
                                }
                                return false;
                            });
                            let novoProdutosSelecionado = [].concat(...produtosSelecionados);
                            if(produtosSelecionadosComMesmoUUID){
                                novoProdutosSelecionado.splice(indice, 1);
                            }else {

                                novoProdutosSelecionado.push(record);
                            }
                            
                            dispatch(atualizaProdutosSelecionados(novoProdutosSelecionado))
                        }
                    }
                }}

                rowSelection={{
                    selectedRowKeys: [].concat(...produtosSelecionados).map(p => p.uuid), 
                    checkStrictly:true,
                    type: "checkbox",
                    rowSelection: true,
                    onChange: (selectedRowKeys, selectedRows) => {
                        // produtosSelecionados = selectedRows
                        dispatch(atualizaProdutosSelecionados(selectedRows))
                      },
                }}
            ></Table>

        </Col>
        <Col span={24} style={{textAlign: "right", marginTop: "10px"}}>
            <Pagination 

                loading={buscandoProdutos}
                current={page}
                defaultCurrent={page} 
                showSizeChanger={false} 
                pageSize={pageSize} 
                total={qtdProdutos} 
                onChange={onChangePagination}
            />
        </Col>
    </Row>
}

export {TabelaProdutos};